import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [
	{ title: 'Think of the Steele Agency' },
	{
		name: 'description',
		content: 'When you think of insurance, think Stan Steele Agency.',
	},
]

export default function Component() {
	return (
		<>
			<h1 className="py-3 text-4xl font-black">Think of Us</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				When you think of insurance, think Stan Steele Agency. When you think of
				the Stan Steele Agency, think
			</p>
			<h3>Service</h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				When it comes to insurance, there is a lot to know. We're here to answer
				your questions and help you make the right decisions for your
				circumstances. We're working hard behind the scenes to take care of your
				policies and your peace of mind.
			</p>
			<h3>Stability</h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				The Steele agency has been in business for over sixty years. We aim to
				build a lifelong relationship of trust and dependability with every
				client.
			</p>
			<h3>Solutions</h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Everyone has different needs and priorities when it comes to protecting
				your treasures. Whether you are considering insurance for your business
				or your family, we'll sit down and get to know you. You will have the
				privilege of teaming up with highly-trained insurance experts to
				customize your insurance program, a program built just for you.
			</p>
			<h3>Savings </h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				When we take you for an insurance shopping spree, one of the objectives
				is to get you into the most competitively priced program that you
				qualify for. Often, this means BIG savings without cutting out coverage.
			</p>
			<h3>Satisfaction</h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				We want you to walk away from every interaction with a smile on your
				face. Put us to the test.
			</p>
			<h3>Speed</h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Our expert staff is here to help, and we'll work hard to meet your needs
				quickly and efficiently. Need an ID card or insurance certificate right
				away? In a hurry to get things done? You've come to the right place.
			</p>
		</>
	)
}
